import { SteamItemType } from '@/entities/platforms/steam/types/types'
import { useStyles } from './styles'
import { GameIdEnum } from '@/entities/cases'
import { $userLanguage } from '@/entities/user'
import { $steamUserData } from '@/entities/platforms/steam/store'
import { useUnit } from 'effector-react'
import { lang } from '@/shared/constants/lang'
import { formatNumber } from '@/shared/util/formatNumber'
import { CoinIcon } from '@/shared/ui/icons'

export default function MostExpensiveItem({ item }: { item: SteamItemType | null }) {
  const { classes } = useStyles({})
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.updatePage
  const steamUserData = useUnit($steamUserData)

  if (!item) return null
  return (
    <div className={classes.root}>
      <span className={classes.heading}>{texts.new_most_expensive}</span>
      <div className={classes.listItem}>
        <img src={item.icon_url} alt={item.name} className={classes.img} />
        <div className={classes.topAndBottomWrapper}>
          <span className={classes.itemTitle}>«{item.name}»</span>
          <div className={classes.bottomContainer}>
            <div className={classes.iconWrapper}>
              <img src={`/assets/webp/icons/${GameIdEnum[item.game_id].toLowerCase()}.webp`} alt="" width="13px" />
              <span className={classes.gameTitle}>{GameIdEnum[item.game_id]}</span>
            </div>
            <div className={classes.itemScoreDiff}>
              <span>{formatNumber(steamUserData!.scoring_diff!.most_expensive_new_item_value)} </span>
              <CoinIcon classes={{ root: classes.coinIcon }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
